export const LoyaltyBenefitIconName = {
  ShippingPackageCheck: "Shipping-PackageCheck",
  ShippingPackageTime: "Shipping-PackageTime",
  ShippingPackageArrow: "Shipping-PackageArrow",
  ShippingPackage: "Shipping-Package",
  ShippingTime: "Shipping-Time",
  CommunicationCustomService: "Communication-CustomService",
  CommunicationChat: "Communication-Chat",
  CommunicationLiveChat: "Communication-LiveChat",
  DiscountBillsAndDiscounts: "Discount-BillsAndDiscounts",
  DiscountGift: "Discount-Gift",
  SpecialsDiamond: "Specials-Diamond",
  SpecialsFire: "Specials-Fire",
  SpecialsStarShinning: "Specials-StarShinning",
} as const;

export type LoyaltyBenefitIconName = (typeof LoyaltyBenefitIconName)[keyof typeof LoyaltyBenefitIconName];

export const loyaltyBenefitIconNames = Object.values(LoyaltyBenefitIconName);
